module.exports = __webpack_public_path__ + "static/media/mizuho.7477ceb4.svg";